'use client';

import type React from 'react';

export interface ExternalVideoProps {
  className?: string;
  controls?: boolean;
  height?: string | number;
  url: string;
  width?: string | number;
}

export const ExternalVideo: React.FC<ExternalVideoProps> = ({
  className = '',
  height = '100%',
  url,
  width = '100%',
}) => (
  <div className={className}>
    <iframe
      width={width}
      height={height}
      src={url}
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      rel="0"
      allowFullScreen
    />
  </div>
);

export default ExternalVideo;
